import {
	useMutation,
	useQueryClient,
	type UseMutationOptions,
} from '@tanstack/react-query';
import {
	mergeAttributeVocabularyValues,
	// mergeAttributeVocabularyValuesEndpoint,
	type QueryError,
	type MergeAttributeVocabularyValuesResult,
	type MergeAttributeVocabularyValuesRequestOptions,
} from '../mergeAttributeVocabularyValues';
import {splitEventHandler} from '@netx/core-next/utils';
import {GetAttributeVocabularyValuesReactQueryKey} from './useReactQueryGetAttributeVocabularyValues';
export * from '../mergeAttributeVocabularyValues';

export type MergeAttributeVocabularyValuesQueryOptions = Omit<
	UseMutationOptions<
		MergeAttributeVocabularyValuesResult,
		QueryError,
		MergeAttributeVocabularyValuesRequestOptions,
		MergeAttributeVocabularyValuesResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof mergeAttributeVocabularyValues;
};

/**
 * react-query wrapper for `mergeAttributeVocabularyValues`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryMergeAttributeVocabularyValues = ({
	mutationFn = mergeAttributeVocabularyValues,
	...options
}: MergeAttributeVocabularyValuesQueryOptions = {}) =>
	useMutation<
		MergeAttributeVocabularyValuesResult,
		QueryError,
		MergeAttributeVocabularyValuesRequestOptions,
		MergeAttributeVocabularyValuesResult
	>({
		mutationFn,
		...options,
	});

export default useReactQueryMergeAttributeVocabularyValues;
